export default "__VITE_ASSET__CccrXEXy__"